(function webpackUniversalModuleDefinition(root, factory) {
  if (typeof exports === 'object' && typeof module === 'object') module.exports = factory(require("jquery"));else if (typeof define === 'function' && define.amd) define(["jquery"], factory);else if (typeof exports === 'object') exports["createElement"] = factory(require("jquery"));else root["createElement"] = factory(root["jquery"]);
})(this, function (__WEBPACK_EXTERNAL_MODULE_2__) {
  return /******/function (modules) {
    // webpackBootstrap
    /******/ // The module cache
    /******/
    var installedModules = {};

    /******/ // The require function
    /******/
    function __webpack_require__(moduleId) {
      /******/ // Check if module is in cache
      /******/if (installedModules[moduleId]) /******/return installedModules[moduleId].exports;

      /******/ // Create a new module (and put it into the cache)
      /******/
      var module = installedModules[moduleId] = {
        /******/exports: {},
        /******/id: moduleId,
        /******/loaded: false
        /******/
      };

      /******/ // Execute the module function
      /******/
      modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

      /******/ // Flag the module as loaded
      /******/
      module.loaded = true;

      /******/ // Return the exports of the module
      /******/
      return module.exports;
      /******/
    }

    /******/ // expose the modules object (__webpack_modules__)
    /******/
    __webpack_require__.m = modules;

    /******/ // expose the module cache
    /******/
    __webpack_require__.c = installedModules;

    /******/ // __webpack_public_path__
    /******/
    __webpack_require__.p = "";

    /******/ // Load entry module and return exports
    /******/
    return __webpack_require__(0);
    /******/
  }
  /************************************************************************/
  /******/([/* 0 */
  /*!**********************!*\
    !*** ./src/index.js ***!
    \**********************/
  /***/function (module, exports, __webpack_require__) {
    var Widget = __webpack_require__(/*! ./widget/base */1);
    var widget = __webpack_require__(/*! ./widget/factory */14);
    widget.Widget = Widget;
    module.exports = widget;

    /***/
  }, /* 1 */
  /*!****************************!*\
    !*** ./src/widget/base.js ***!
    \****************************/
  /***/function (module, exports, __webpack_require__) {
    var $ = __webpack_require__(/*! jquery */2);
    var extend = __webpack_require__(/*! ../util/extend */3);
    var vd = __webpack_require__(/*! ../virtual-dom */4);
    __webpack_require__(/*! ./helper */13);
    var rfunctionName = /\bfunction(?:\s+([\w$]+))?\s*\(/;
    var anonymousWidgetIndex = 0;
    var widgetUuid = 0;
    function Widget(options) {
      if (this._createWidget) {
        this.getWidgetName();
        this._createWidget(options);
      }
    }
    Widget.prototype = {
      widgetName: null,
      defaultElement: "<div>",
      options: {
        classes: {},
        disabled: false,
        // Callbacks
        create: null
      },
      getWidgetName: function () {
        if (!this.widgetName) {
          var widgetName;
          if (Function.name) {
            widgetName = this.constructor.name;
          } else {
            widgetName = this.constructor.toString().match(rfunctionName)[1];
          }
          this.widgetName = widgetName || 'Anonymous' + ++anonymousWidgetIndex;
        }
        return this.widgetName;
      },
      createWidget: function (widget, props, children) {
        var vdom;
        children = Array.prototype.slice.call(arguments, 2);
        if (typeof widget === 'string') {
          vdom = new vd.VNode(widget, props, children, this);
        } else {
          vdom = new vd.VWidget(widget, props, this);
        }
        return vdom;
      },
      _createWidget: function (options) {
        this.options = extend({}, this.options, this._getCreateOptions(), options);
        this.bindings = $();
        this.hoverable = $();
        this.focusable = $();
        this.classesElementLookup = {};
        this.uuid = widgetUuid++;
        this.eventNamespace = "." + this.widgetName + this.uuid;
        this.subWidgets = [];
        this.vtree = this.render();
        this.element = this.vtree ? this.vtree.render() : $(this.defaultElement);
        var element = this.element[0];
        $.data(element, 'widget-' + this.widgetName, this);
        $.data(element, 'widget', this.widgetName);
        this._on(true, this.element, {
          remove: function (event) {
            if (event.target === element) {
              this.destroy();
            }
          }
        });
        this.document = $(element.style ?
        // Element within the document
        element.ownerDocument :
        // Element is window or document
        element.document || element);
        this.window = $(this.document[0].defaultView || this.document[0].parentWindow);
        this._create();
        if (this.options.disabled) {
          this._setOptionDisabled(this.options.disabled);
        }
        this._trigger("create", null, this._getCreateEventData());
        this._init();
      },
      _getCreateOptions: function () {
        return {};
      },
      _getCreateEventData: $.noop,
      _create: $.noop,
      _init: $.noop,
      destroy: function () {
        var that = this;
        this._destroy();
        $.each(this.classesElementLookup, function (key, value) {
          that._removeClass(value, key);
        });

        // We can probably remove the unbind calls in 2.0
        // all event bindings should go through this._on()
        this.element.off(this.eventNamespace).removeData('widget', 'widget-' + this.widgetName);
        this.widget().off(this.eventNamespace).removeAttr("aria-disabled");

        // Clean up events and states
        this.bindings.off(this.eventNamespace);
        $.each(this.subWidgets, function (index, instance) {
          instance.destroy();
        });
        this.element.remove();
      },
      _destroy: $.noop,
      widget: function () {
        return this.element;
      },
      option: function (key, value) {
        var options = key;
        var parts;
        var curOption;
        var i;
        if (arguments.length === 0) {
          // Don't return a reference to the internal hash
          return extend({}, this.options);
        }
        if (typeof key === "string") {
          // Handle nested keys, e.g., "foo.bar" => { foo: { bar: ___ } }
          options = {};
          parts = key.split(".");
          key = parts.shift();
          if (parts.length) {
            curOption = options[key] = extend({}, this.options[key]);
            for (i = 0; i < parts.length - 1; i++) {
              curOption[parts[i]] = curOption[parts[i]] || {};
              curOption = curOption[parts[i]];
            }
            key = parts.pop();
            if (arguments.length === 1) {
              return curOption[key] === undefined ? null : curOption[key];
            }
            curOption[key] = value;
          } else {
            if (arguments.length === 1) {
              return this.options[key] === undefined ? null : this.options[key];
            }
            options[key] = value;
          }
        }
        this._setOptions(options);
        return this;
      },
      _setOptions: function (options) {
        var key;
        for (key in options) {
          this._setOption(key, options[key]);
        }
        if (!this.element.data('widget')) {
          return;
        }
        var vtree = this.render();
        var patches = vd.diff(this.vtree, vtree).patches;
        vd.patch(this.element, patches);
        this.vtree = vtree;
        return this;
      },
      _setOption: function (key, value) {
        if (key === "classes") {
          this._setOptionClasses(value);
        }
        this.options[key] = $.isPlainObject(value) ? extend({}, value) : value;
        if (key === "disabled") {
          this._setOptionDisabled(value);
        }
        return this;
      },
      _setOptionClasses: function (value) {
        var classKey, elements, currentElements;
        for (classKey in value) {
          currentElements = this.classesElementLookup[classKey];
          if (value[classKey] === this.options.classes[classKey] || !currentElements || !currentElements.length) {
            continue;
          }

          // We are doing this to create a new jQuery object because the _removeClass() call
          // on the next line is going to destroy the reference to the current elements being
          // tracked. We need to save a copy of this collection so that we can add the new classes
          // below.
          elements = $(currentElements.get());
          this._removeClass(currentElements, classKey);

          // We don't use _addClass() here, because that uses this.options.classes
          // for generating the string of classes. We want to use the value passed in from
          // _setOption(), this is the new value of the classes option which was passed to
          // _setOption(). We pass this value directly to _classes().
          elements.addClass(this._classes({
            element: elements,
            keys: classKey,
            classes: value,
            add: true
          }));
        }
      },
      _setOptionDisabled: function (value) {
        this._toggleClass(this.widget(), this.widgetName + "-disabled", null, !!value);

        // If the widget is becoming disabled, then nothing is interactive
        if (value) {
          this._removeClass(this.hoverable, null, "ui-state-hover");
          this._removeClass(this.focusable, null, "ui-state-focus");
        }
      },
      enable: function () {
        return this._setOptions({
          disabled: false
        });
      },
      disable: function () {
        return this._setOptions({
          disabled: true
        });
      },
      _classes: function (options) {
        var full = [];
        var that = this;
        options = $.extend({
          element: this.element,
          classes: this.options.classes || {}
        }, options);
        function processClassString(classes, checkOption) {
          var current, i;
          for (i = 0; i < classes.length; i++) {
            current = that.classesElementLookup[classes[i]] || $();
            if (options.add) {
              current = $($.unique(current.get().concat(options.element.get())));
            } else {
              current = $(current.not(options.element).get());
            }
            that.classesElementLookup[classes[i]] = current;
            full.push(classes[i]);
            if (checkOption && options.classes[classes[i]]) {
              full.push(options.classes[classes[i]]);
            }
          }
        }
        if (options.keys) {
          processClassString(options.keys.match(/\S+/g) || [], true);
        }
        if (options.extra) {
          processClassString(options.extra.match(/\S+/g) || []);
        }
        return full.join(" ");
      },
      _removeClass: function (element, keys, extra) {
        return this._toggleClass(element, keys, extra, false);
      },
      _addClass: function (element, keys, extra) {
        return this._toggleClass(element, keys, extra, true);
      },
      _toggleClass: function (element, keys, extra, add) {
        add = typeof add === "boolean" ? add : extra;
        var shift = typeof element === "string" || element === null,
          options = {
            extra: shift ? keys : extra,
            keys: shift ? element : keys,
            element: shift ? this.element : element,
            add: add
          };
        options.element.toggleClass(this._classes(options), add);
        return this;
      },
      _on: function (suppressDisabledCheck, element, handlers) {
        var delegateElement;
        var instance = this;

        // No suppressDisabledCheck flag, shuffle arguments
        if (typeof suppressDisabledCheck !== "boolean") {
          handlers = element;
          element = suppressDisabledCheck;
          suppressDisabledCheck = false;
        }

        // No element argument, shuffle and use this.element
        if (!handlers) {
          handlers = element;
          element = this.element;
          delegateElement = this.widget();
        } else {
          element = delegateElement = $(element);
          this.bindings = this.bindings.add(element);
        }
        $.each(handlers, function (event, handler) {
          function handlerProxy() {
            // Allow widgets to customize the disabled handling
            // - disabled as an array instead of boolean
            // - disabled class as method for disabling individual parts
            if (!suppressDisabledCheck && (instance.options.disabled === true || $(this).hasClass("ui-state-disabled"))) {
              return;
            }
            return (typeof handler === "string" ? instance[handler] : handler).apply(instance, arguments);
          }

          // Copy the guid so direct unbinding works
          if (typeof handler !== "string") {
            handlerProxy.guid = handler.guid = handler.guid || handlerProxy.guid || $.guid++;
          }
          var match = event.match(/^([\w:-]*)\s*(.*)$/);
          var eventName = match[1] + instance.eventNamespace;
          var selector = match[2];
          if (selector) {
            delegateElement.on(eventName, selector, handlerProxy);
          } else {
            element.on(eventName, handlerProxy);
          }
        });
      },
      _off: function (element, eventName) {
        eventName = (eventName || "").split(" ").join(this.eventNamespace + " ") + this.eventNamespace;
        element.off(eventName).off(eventName);

        // Clear the stack to avoid memory leaks (#10056)
        this.bindings = $(this.bindings.not(element).get());
        this.focusable = $(this.focusable.not(element).get());
        this.hoverable = $(this.hoverable.not(element).get());
      },
      _delay: function (handler, delay) {
        function handlerProxy() {
          return (typeof handler === "string" ? instance[handler] : handler).apply(instance, arguments);
        }
        var instance = this;
        return setTimeout(handlerProxy, delay || 0);
      },
      _hoverable: function (element) {
        this.hoverable = this.hoverable.add(element);
        this._on(element, {
          mouseenter: function (event) {
            this._addClass($(event.currentTarget), null, "ui-state-hover");
          },
          mouseleave: function (event) {
            this._removeClass($(event.currentTarget), null, "ui-state-hover");
          }
        });
      },
      _focusable: function (element) {
        this.focusable = this.focusable.add(element);
        this._on(element, {
          focusin: function (event) {
            this._addClass($(event.currentTarget), null, "ui-state-focus");
          },
          focusout: function (event) {
            this._removeClass($(event.currentTarget), null, "ui-state-focus");
          }
        });
      },
      _trigger: function (type, event, data) {
        var prop, orig;
        var callback = this.options[type];
        data = data || {};
        event = $.Event(event);
        event.type = (this.widgetName + ':' + type).toLowerCase();

        // The original event may come from any element
        // so we need to reset the target on the new event
        event.target = this.element[0];

        // Copy original event properties over to the new event
        orig = event.originalEvent;
        if (orig) {
          for (prop in orig) {
            if (!(prop in event)) {
              event[prop] = orig[prop];
            }
          }
        }
        this.element.trigger(event, data);
        return !($.isFunction(callback) && callback.apply(this.element[0], [event].concat(data)) === false || event.isDefaultPrevented());
      },
      render: function () {
        return null;
      }
    };
    $.each({
      show: "fadeIn",
      hide: "fadeOut"
    }, function (method, defaultEffect) {
      Widget.prototype["_" + method] = function (element, options, callback) {
        if (typeof options === "string") {
          options = {
            effect: options
          };
        }
        var hasOptions;
        var effectName = !options ? method : options === true || typeof options === "number" ? defaultEffect : options.effect || defaultEffect;
        options = options || {};
        if (typeof options === "number") {
          options = {
            duration: options
          };
        }
        hasOptions = !$.isEmptyObject(options);
        options.complete = callback;
        if (options.delay) {
          element.delay(options.delay);
        }
        if (hasOptions && $.effects && $.effects.effect[effectName]) {
          element[method](options);
        } else if (effectName !== method && element[effectName]) {
          element[effectName](options.duration, options.easing, callback);
        } else {
          element.queue(function (next) {
            $(this)[method]();
            if (callback) {
              callback.call(element[0]);
            }
            next();
          });
        }
      };
    });
    module.exports = Widget;

    /***/
  }, /* 2 */
  /*!*************************!*\
    !*** external "jquery" ***!
    \*************************/
  /***/function (module, exports) {
    module.exports = __WEBPACK_EXTERNAL_MODULE_2__;

    /***/
  }, /* 3 */
  /*!****************************!*\
    !*** ./src/util/extend.js ***!
    \****************************/
  /***/function (module, exports, __webpack_require__) {
    var $ = __webpack_require__(/*! jquery */2);
    var slice = Array.prototype.slice;
    var extend = function (target) {
      var input = slice.call(arguments, 1);
      var inputIndex = 0;
      var inputLength = input.length;
      var key;
      var value;
      for (; inputIndex < inputLength; inputIndex++) {
        for (key in input[inputIndex]) {
          value = input[inputIndex][key];
          if (input[inputIndex].hasOwnProperty(key) && value !== undefined) {
            // Clone objects
            if ($.isPlainObject(value)) {
              target[key] = $.isPlainObject(target[key]) ? extend({}, target[key], value) :
              // Don't extend strings, arrays, etc. with objects
              extend({}, value);

              // Copy everything else by reference
            } else {
              target[key] = value;
            }
          }
        }
      }
      return target;
    };
    module.exports = extend;

    /***/
  }, /* 4 */
  /*!**********************************!*\
    !*** ./src/virtual-dom/index.js ***!
    \**********************************/
  /***/function (module, exports, __webpack_require__) {
    var VText = __webpack_require__(/*! ./vtext */5);
    var VNode = __webpack_require__(/*! ./vnode */8);
    var VWidget = __webpack_require__(/*! ./vwidget */9);
    var diff = __webpack_require__(/*! ./diff */10);
    var patch = __webpack_require__(/*! ./patch */12);
    exports.VText = VText;
    exports.VNode = VNode;
    exports.VWidget = VWidget;
    exports.diff = diff;
    exports.patch = patch;

    /***/
  }, /* 5 */
  /*!**********************************!*\
    !*** ./src/virtual-dom/vtext.js ***!
    \**********************************/
  /***/function (module, exports, __webpack_require__) {
    var VDOM = __webpack_require__(/*! ./vdom */6);
    var inherit = __webpack_require__(/*! ../util/inherit */7);
    var $ = __webpack_require__(/*! jquery */2);
    function VText(text) {
      VDOM.call(this);
      this.text = text.toString();
    }
    inherit(VText, VDOM);
    VText.prototype.render = function () {
      return $(document.createTextNode(this.text));
    };
    module.exports = VText;

    /***/
  }, /* 6 */
  /*!*********************************!*\
    !*** ./src/virtual-dom/vdom.js ***!
    \*********************************/
  /***/function (module, exports, __webpack_require__) {
    var $ = __webpack_require__(/*! jquery */2);
    var reventProperty = /^on/;
    function VDOM(props, children, context) {
      this.props = props || {};
      this.children = children || [];
      this.context = context;
    }
    VDOM.prototype = {
      makeKey: function (index) {
        if ('id' in this.props) {
          this.key = this.props['id'];
        } else if ('data-id' in this.props) {
          this.key = this.props['data-id'];
        } else {
          this.key = index;
        }
      },
      parse: function (props) {
        var attributes = {},
          events = {},
          propertyName;
        props = props || this.props;
        for (propertyName in props) {
          if (props.hasOwnProperty(propertyName)) {
            if (reventProperty.test(propertyName)) {
              events[propertyName.slice(2)] = props[propertyName];
            } else {
              attributes[propertyName] = props[propertyName];
            }
          }
        }
        return {
          attributes: attributes,
          events: events
        };
      },
      addEvent: function (events, element) {
        var name,
          handler,
          widgetEvents = {},
          widget = this.context;
        for (name in events) {
          if (events.hasOwnProperty(name)) {
            handler = events[name];
            if (handler === null) {
              widget._off(element, name);
            } else {
              widgetEvents[name] = typeof handler === 'string' ? handler : $.proxy(handler, widget);
            }
          }
        }
        widget._on(element, widgetEvents);
      }
    };
    module.exports = VDOM;

    /***/
  }, /* 7 */
  /*!*****************************!*\
    !*** ./src/util/inherit.js ***!
    \*****************************/
  /***/function (module, exports) {
    module.exports = function (child, parent) {
      function proxy() {}
      proxy.prototype = parent.prototype;
      child.prototype = new proxy();
      child.prototype.constructor = child;
    };

    /***/
  }, /* 8 */
  /*!**********************************!*\
    !*** ./src/virtual-dom/vnode.js ***!
    \**********************************/
  /***/function (module, exports, __webpack_require__) {
    var VDOM = __webpack_require__(/*! ./vdom */6);
    var inherit = __webpack_require__(/*! ../util/inherit */7);
    var VText = __webpack_require__(/*! ./vtext */5);
    var $ = __webpack_require__(/*! jquery */2);
    var attrfix = {
      classname: 'class',
      htmlfor: 'for'
    };
    function VNode(tagName, props, children, context) {
      VDOM.call(this, props, children, context);
      this.tagName = tagName;
      children = [];
      for (var i = 0, child; i < this.children.length; i++) {
        child = this.children[i];
        if ($.isArray(child)) {
          child.unshift(1);
          child.unshift(i);
          Array.prototype.splice.apply(this.children, child);
          i--;
        } else {
          if (child == null) {
            continue;
          } else if (typeof child === 'string' || typeof child === 'number') {
            child = new VText(child);
          }
          child.makeKey(i);
          children.push(child);
        }
      }
      this.children = children;
    }
    inherit(VNode, VDOM);
    VNode.prototype.parse = function (props) {
      var result = VDOM.prototype.parse.call(this, props);
      var attributes = {};
      $.each(result.attributes, function (key, value) {
        attributes[attrfix[key] || key] = value;
      });
      result.attributes = attributes;
      return result;
    };
    VNode.prototype.render = function () {
      var result = this.parse();
      var element = $('<' + this.tagName + '>', result.attributes);
      this.addEvent(result.events, element);
      element.append($.map(this.children, function (child) {
        return child.render();
      }));
      return element;
    };
    VNode.prototype.update = function (props, element) {
      var result = this.parse(props),
        eventsRemove = {},
        eventsUpdate = {};
      $.each(result.attributes, function (key, value) {
        if (value == null) {
          element.removeProp(key);
          element.removeAttr(key);
        } else {
          element.prop(key, value);
          element.attr(key, value);
        }
      });
      $.each(result.events, function (key, value) {
        eventsRemove[key] = null;
        if (value != null) {
          eventsUpdate[key] = value;
        }
      });
      this.addEvent(eventsRemove, element);
      this.addEvent(eventsUpdate, element);
    };
    module.exports = VNode;

    /***/
  }, /* 9 */
  /*!************************************!*\
    !*** ./src/virtual-dom/vwidget.js ***!
    \************************************/
  /***/function (module, exports, __webpack_require__) {
    var VDOM = __webpack_require__(/*! ./vdom */6);
    var inherit = __webpack_require__(/*! ../util/inherit */7);
    function VWidget(widget, props, context) {
      VDOM.call(this, props, null, context);
      this.widget = widget;
      //this.key = this.makeKey(widget.prototype.getWidgetName()); TODO getWidgetName should drop?
    }
    inherit(VWidget, VDOM);
    VWidget.prototype.parse = function (widgetName, props) {
      var result = VDOM.prototype.parse.call(this, props);
      var events = {},
        eventName;
      for (eventName in result.events) {
        if (result.events.hasOwnProperty(eventName)) {
          events[(widgetName + ':' + eventName).toLowerCase()] = result.events[eventName];
        }
      }
      result.events = events;
      return result;
    };
    VWidget.prototype.render = function () {
      var widget = new this.widget(this.props);
      var element = widget.element;
      var result = this.parse(widget.widgetName);
      this.context.subWidgets.push(widget);
      this.addEvent(result.events, element);
      return element;
    };
    VWidget.prototype.update = function (props, element) {
      var result = this.parse(element.data('widget'), props);
      this.addEvent(result.events, element);
      element.data('widget-' + element.data('widget')).option(props);
    };
    module.exports = VWidget;

    /***/
  }, /* 10 */
  /*!*********************************!*\
    !*** ./src/virtual-dom/diff.js ***!
    \*********************************/
  /***/function (module, exports, __webpack_require__) {
    var patchType = __webpack_require__(/*! ./constant/patchType */11);
    var VText = __webpack_require__(/*! ./vtext */5);
    var VNode = __webpack_require__(/*! ./vnode */8);
    var VWidget = __webpack_require__(/*! ./vwidget */9);
    var $ = __webpack_require__(/*! jquery */2);
    function diff(oldTree, newTree) {
      if (!(this instanceof diff)) {
        return new diff(oldTree, newTree);
      }
      this.index = -1;
      this.patches = {};
      this.walk(oldTree, newTree);
    }
    diff.prototype = {
      walk: function (oldTree, newTree) {
        var patch = [],
          index = ++this.index;
        if (!oldTree || !newTree) {
          return;
        } else if (oldTree.constructor !== newTree.constructor) {
          patch.push({
            type: patchType.REPLACE,
            node: newTree
          });
        } else {
          if (oldTree.constructor === VText) {
            if (oldTree.text !== newTree.text) {
              patch.push({
                type: patchType.REPLACE,
                node: newTree
              });
            }
          } else if (oldTree.constructor === VNode) {
            if (oldTree.tagName !== newTree.tagName) {
              patch.push({
                type: patchType.REPLACE,
                node: newTree
              });
            } else {
              var diffProps = this.diffProps(oldTree.props, newTree.props);
              if (diffProps) {
                patch.push({
                  type: patchType.PROPS,
                  node: newTree,
                  props: diffProps
                });
              }
              var diffChildren = this.diffChildren(oldTree.children, newTree.children);
              if (diffChildren.move.length) {
                patch.push({
                  type: patchType.REORDER,
                  move: diffChildren.move
                });
              }
              for (var i = 0, len = newTree.children.length; i < len; i++) {
                this.walk(diffChildren.children[i], newTree.children[i]);
              }
            }
          } else if (oldTree.constructor === VWidget) {
            if (oldTree.widget.prototype.getWidgetName() !== newTree.widget.prototype.getWidgetName()) {
              patch.push({
                type: patchType.REPLACE,
                node: newTree
              });
            } else {
              var diffProps = this.diffProps(oldTree.props, newTree.props); //eslint-disable-line
              if (diffProps) {
                patch.push({
                  type: patchType.PROPS,
                  node: newTree,
                  props: diffProps
                });
              }
            }
          }
        }
        if (patch.length) {
          this.patches[index] = patch;
        }
      },
      diffProps: function (oldProps, newProps) {
        var diffProps = {},
          that = this;
        $.each(oldProps, function (key, value) {
          var newValue = newProps[key];
          if (!(key in newProps)) {
            diffProps[key] = null;
          } else if ($.isPlainObject(value) && $.isPlainObject(newValue)) {
            var dp = that.diffProps(value, newValue);
            if (dp) {
              diffProps[key] = newValue;
            }
          } else if ($.isFunction(value) && $.isFunction(newValue)) {
            if (value !== newValue && value.toString() !== newValue.toString()) {
              diffProps[key] = newValue;
            }
          } else if (value !== newValue) {
            diffProps[key] = newValue;
          }
        });
        $.each(newProps, function (key, value) {
          if (!(key in oldProps)) {
            diffProps[key] = value;
          }
        });
        return $.isEmptyObject(diffProps) ? null : diffProps;
      },
      diffChildren: function (oldChildren, newChildren) {
        var getIndex = function (list) {
          var hash = {};
          for (var i = 0, len = list.length; i < len; i++) {
            hash[list[i].key] = i;
          }
          return hash;
        };
        var oldIndex = getIndex(oldChildren);
        var newIndex = getIndex(newChildren);
        var move = [],
          children = [],
          transChildren = [],
          inserted = {};
        var i, len, node, j;
        for (i = 0, len = oldChildren.length; i < len; i++) {
          node = oldChildren[i];
          if (newIndex[node.key] > -1) {
            transChildren.push(newChildren[newIndex[node.key]]);
          } else {
            move.push({
              type: patchType.REMOVE,
              index: i
            });
          }
        }
        j = 0;
        for (i = 0, len = newChildren.length; i < len; i++) {
          node = newChildren[i];
          if (oldIndex[node.key] > -1) {
            children[i] = oldChildren[oldIndex[node.key]];
          } else {
            children[i] = node;
          }
          if (transChildren[j]) {
            if (node.key === transChildren[j].key) {
              j++;
              while (transChildren[j] && inserted[transChildren[j].key]) {
                move.push({
                  type: patchType.REMOVE,
                  index: j
                });
                j++;
              }
            } else {
              move.push({
                type: patchType.INSERT,
                node: node,
                index: j
              });
              inserted[node.key] = true;
            }
          } else {
            move.push({
              type: patchType.INSERT,
              node: node,
              index: j
            });
          }
        }
        return {
          move: move,
          children: children
        };
      }
    };
    module.exports = diff;

    /***/
  }, /* 11 */
  /*!***********************************************!*\
    !*** ./src/virtual-dom/constant/patchType.js ***!
    \***********************************************/
  /***/function (module, exports) {
    module.exports = {
      INSERT: 'insert',
      PROPS: 'props',
      REMOVE: 'remove',
      REORDER: 'reorder',
      REPLACE: 'replace'
    };

    /***/
  }, /* 12 */
  /*!**********************************!*\
    !*** ./src/virtual-dom/patch.js ***!
    \**********************************/
  /***/function (module, exports, __webpack_require__) {
    var patchType = __webpack_require__(/*! ./constant/patchType */11);
    var $ = __webpack_require__(/*! jquery */2);
    function patch(node, patches) {
      if (!(this instanceof patch)) {
        return new patch(node, patches);
      }
      this.root = node;
      this.widget = this.root.data('widget-' + this.root.data('widget'));
      this.patches = patches;
      this.patchesRemaining = 0;
      for (var key in patches) {
        if (patches.hasOwnProperty(key)) {
          this.patchesRemaining++;
        }
      }
      this.index = -1;
      this.walk(node[0]);
    }
    patch.prototype = {
      walk: function (node) {
        var index = ++this.index;
        var patch = this.patches[index];
        if (patch) {
          this.applyPatch(node, patch);
          this.patchesRemaining--;
        }
        if (this.patchesRemaining > 0 && (node === this.root[0] || node && node.nodeType === 1 && !$.data(node, 'widget'))) {
          var childNodes = node.childNodes;
          for (var i = 0, len = childNodes.length; i < len; i++) {
            if (this.walk(childNodes[i])) {
              break;
            }
          }
        }
        return this.patchesRemaining === 0;
      },
      applyPatch: function (node, patches) {
        for (var i = 0, len = patches.length, patch; i < len; i++) {
          patch = patches[i];
          switch (patch.type) {
            case patchType.PROPS:
              this.patchProps(node, patch.node, patch.props);
              break;
            case patchType.REORDER:
              this.patchReorder(node, patch.move);
              break;
            case patchType.REPLACE:
              this.patchReplace(node, patch.node);
              break;
          }
        }
      },
      patchProps: function (node, vdom, props) {
        vdom.update(props, $(node), this.widget);
      },
      patchReorder: function (node, move) {
        var childNodes = Array.prototype.slice.call(node.childNodes, 0);
        var remove = [],
          insert = [],
          tmp = [];
        var i, len, item;
        for (i = 0, len = move.length; i < len; i++) {
          item = move[i];
          if (item.type === patchType.REMOVE) {
            remove.push({
              method: 'removeChild',
              args: [childNodes[item.index]]
            });
            childNodes.splice(item.index, 1, null);
          } else {
            break;
          }
        }
        insert = move.slice(i);
        for (i = 0, len = childNodes.length; i < len; i++) {
          item = childNodes[i];
          if (item !== null) {
            tmp.push(item);
          }
        }
        childNodes = tmp;
        for (i = 0, len = insert.length; i < len; i++) {
          if (insert[i].type === patchType.INSERT) {
            item = insert[i].node.render(this.widget)[0];
            if (childNodes[insert[i].index]) {
              insert[i] = {
                method: 'insertBefore',
                args: [item, childNodes[insert[i].index]]
              };
            } else {
              insert[i] = {
                method: 'appendChild',
                args: [item]
              };
            }
          } else if (insert[i].type === patchType.REMOVE) {
            insert[i] = {
              method: 'removeChild',
              args: [childNodes[insert[i].index]]
            };
          }
        }
        tmp = remove.concat(insert);
        for (i = 0, len = tmp.length; i < len; i++) {
          item = tmp[i];
          node[item.method].apply(node, item.args);
        }
      },
      patchReplace: function (node, vdom) {
        var newNode = vdom.render(this.widget)[0];
        node.parentNode.insertBefore(newNode, node);
        node.parentNode.removeChild(node);
      }
    };
    module.exports = patch;

    /***/
  }, /* 13 */
  /*!******************************!*\
    !*** ./src/widget/helper.js ***!
    \******************************/
  /***/function (module, exports, __webpack_require__) {
    var $ = __webpack_require__(/*! jquery */2);
    $.cleanData = function (orig) {
      return function (elems) {
        var events, elem, i;
        for (i = 0; (elem = elems[i]) != null; i++) {
          try {
            // Only trigger remove when necessary to save time
            events = $._data(elem, "events");
            if (events && events.remove) {
              $(elem).triggerHandler("remove");
            }

            // Http://bugs.jquery.com/ticket/8235
          } catch (e) {} //eslint-disable-line
        }
        orig(elems);
      };
    }($.cleanData);

    /***/
  }, /* 14 */
  /*!*******************************!*\
    !*** ./src/widget/factory.js ***!
    \*******************************/
  /***/function (module, exports, __webpack_require__) {
    var $ = __webpack_require__(/*! jquery */2);
    var extend = __webpack_require__(/*! ../util/extend */3);
    var Widget = __webpack_require__(/*! ./base */1);
    var anonymousWidgetIndex = 0;
    function widget(name, base, prototype) {
      var constructor, basePrototype, globalVarBak;
      var bridge = function () {};

      // ProxiedPrototype allows the provided prototype to remain unmodified
      // so that it can be used as a mixin for multiple widgets (#8876)
      var proxiedPrototype = {};
      if (typeof name !== 'string') {
        prototype = base;
        base = name;
        name = 'anonymous' + ++anonymousWidgetIndex;
      }
      if (!prototype) {
        prototype = base;
        base = Widget;
      }
      if ($.isArray(prototype)) {
        prototype = $.extend.apply(null, [{}].concat(prototype));
      }
      globalVarBak = window[name];
      window.eval(['window.' + name + ' = function ' + name + '( options ) {',
      // Allow instantiation without "new" keyword
      'if ( !this._createWidget ) {', '    return new ' + name + '( options );', '}', 'this._createWidget( options );', '};'].join(''));
      constructor = window[name];
      if (typeof bak === 'undefined') {
        delete window[name];
      } else {
        window[name] = globalVarBak;
      }
      bridge.prototype = base.prototype;
      basePrototype = new bridge();

      // We need to make the options hash a property directly on the new instance
      // otherwise we'll modify the options hash on the prototype that we're
      // inheriting from
      basePrototype.options = extend({}, basePrototype.options);
      $.each(prototype, function (prop, value) {
        if (!$.isFunction(value)) {
          proxiedPrototype[prop] = value;
          return;
        }
        proxiedPrototype[prop] = function () {
          function _super() {
            return base.prototype[prop].apply(this, arguments);
          }
          function _superApply(args) {
            return base.prototype[prop].apply(this, args);
          }
          return function () {
            var __super = this._super;
            var __superApply = this._superApply;
            var returnValue;
            this._super = _super;
            this._superApply = _superApply;
            returnValue = value.apply(this, arguments);
            this._super = __super;
            this._superApply = __superApply;
            return returnValue;
          };
        }();
      });
      constructor.prototype = extend(basePrototype, proxiedPrototype, {
        constructor: constructor,
        widgetName: name
      });
      return constructor;
    }
    module.exports = widget;

    /***/
  }
  /******/]);
});
;